import { fireLinkTag } from './tagManager';

const fireOnlyOnceSet = new Set([]);

/**
 * @param {{
 *  videoTimeViewed: number,
 *  videoDuration: number,
 *  data: { video_id: string[], product_id: string[], product_name: string[]}
 * }} payload
 * @param {'start' | 'pause' | 'timeupdate'} tagType
 *
 */
// eslint-disable-next-line complexity
export function tagVideo({ videoTimeViewed, videoDuration, data }, tagType) {
  const viewedPercentage = (videoTimeViewed / videoDuration) * 100;
  switch (tagType) {
  case 'start':
    if (videoTimeViewed === 0) {
      fireLinkTag({
        event_name: 'video start',
        video_time_viewed: [videoTimeViewed.toString()],
        ...data,
      });
    }
    break;
  case 'pause':
    fireLinkTag({
      event_name: 'video pause',
      video_time_viewed: [videoTimeViewed.toString()],
      ...data,
    });
    break;
  case 'timeupdate':
    if (viewedPercentage >= 25 && !fireOnlyOnceSet.has(25)) {
      fireOnlyOnceSet.add(25);
      fireLinkTag({
        event_name: 'video 25%',
        video_time_viewed: [videoTimeViewed.toString()],
        ...data,
      });
    } else if (viewedPercentage >= 50 && !fireOnlyOnceSet.has(50)) {
      fireOnlyOnceSet.add(50);
      fireLinkTag({
        event_name: 'video 50%',
        video_time_viewed: [videoTimeViewed.toString()],
        ...data,
      });
    } else if (viewedPercentage >= 75 && !fireOnlyOnceSet.has(75)) {
      fireOnlyOnceSet.add(75);
      fireLinkTag({
        event_name: 'video 75%',
        video_time_viewed: [videoTimeViewed.toString()],
        ...data,
      });
    } else if (videoTimeViewed === videoDuration) {
      fireOnlyOnceSet.clear();
      fireLinkTag({
        event_name: 'video complete',
        video_time_viewed: [videoTimeViewed.toString()],
        ...data,
      });
    }
    break;
  default:
  }
}

export default tagVideo;
